<template>
  <div class="little-academy-authen-layout">
    <nuxt />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
#__nuxt,
#__layout {
  height: 100%;
}
.little-academy-authen-layout {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-image: asset('images/signin-bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
